import { render, staticRenderFns } from "./AutocompleteFacet.vue?vue&type=template&id=236b2a09"
import script from "./AutocompleteFacet.vue?vue&type=script&lang=js"
export * from "./AutocompleteFacet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports